<template>
  <basic-container>
    <el-row>
      <el-col span="12">
        <avue-form ref="config" :option="configOption" v-model="excelForm">


          
          <template slot-scope="{disabled,size}" slot="offsetMoney">
            <el-input 
            placeholder="请输入偏移量"
              v-model="excelForm.offsetMoney"
            ></el-input>
          </template>
<template slot-scope="{}" slot="tableListLabel">
  <div>
    <span> &nbsp;&nbsp;</span>

  </div>

</template>
          <template slot-scope="{disabled,size}" slot="tableList">
    <div>
     
     
     <el-table
            height="300"
            :data="excelForm.tableList"
            border
            style="width: 100%">

            <el-table-column
      align="center">
      <template slot="header" slot-scope="scope">
        <el-button type="primary" icon="el-icon-plus" circle @click="addItemHandler"></el-button>
      </template>
      <template slot-scope="scope">
        <el-button type="danger" icon="el-icon-minus" circle @click="deleteItemHandler(scope)"></el-button>
      </template>
            </el-table-column>


            
            <el-table-column
              label="子费项名称"
              prop="feeItemName">
              
      <template slot-scope="scope">
        
                  <el-form-item label-width="0" :prop="`tableList[${scope.$index}].sortType`" :rules="[{
                    required:true,
message: '请选择子费项名称', trigger: 'change'
                  }]">
        <el-select
          v-model="scope.row.sortType"
          size="mini"
          placeholder="请选择子费项名称"
        >
              <el-option
                style="padding-left: 10px;"
                v-for="item in enableSortTypeAddtionList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
        </el-select>
                  </el-form-item>
      </template>
            </el-table-column>


            
            <el-table-column
              label="计费方式"
              prop="feeType">


      <template slot-scope="scope">
        
                  <el-form-item label-width="0" :prop="`tableList[${scope.$index}].feeType`" :rules="[{
                    required:true,
message: '请选择计费方式', trigger: 'change'
                  }]">
        <el-select
        
          v-model="scope.row.feeType"
          size="mini"
          placeholder="请选择计费方式"
        >
              <el-option
                style="padding-left: 10px;"
                v-for="item in feeTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
        </el-select>
                  </el-form-item>
      </template>


            </el-table-column>


            
            <el-table-column
              label="计价类型"
              prop="date">


              

      <template slot-scope="scope">
        
                  <el-form-item label-width="0" :prop="`tableList[${scope.$index}].priceSet`" :rules="[{
                    required:true,
message: '请选择计价类型', trigger: 'change'
                  }]">
        <el-select
        
          v-model="scope.row.priceSet"
          size="mini"
          placeholder="请选择计价类型"
        >
              <el-option
                style="padding-left: 10px;"
                v-for="item in priceSetList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
        </el-select>
                  </el-form-item>
      </template>



            </el-table-column>


            <el-table-column
              label="金额"
              prop="unitPrice">



      <template slot-scope="scope">
                  <el-form-item label-width="0" :prop="`tableList[${scope.$index}].unitPrice`" :rules="[{
                    required:true,
message: '请输入金额', trigger: 'change'
                  }]">
        <el-input
          v-model="scope.row.unitPrice"
          size="mini"
          placeholder="请输入金额"
        ></el-input>
                  </el-form-item>
      </template>
            </el-table-column>

              



            <el-table-column
              label="是否拆分账单"
              prop="date">



      <template slot-scope="scope">
        
                  <el-form-item label-width="0" :prop="`tableList[${scope.$index}].splitFlag`" :rules="[{
                    required:true,
message: '请选择计价类型', trigger: 'change'
                  }]">
        
        <el-select
        
          v-model="scope.row.splitFlag"
          size="mini"
          placeholder="请选择是否拆分账单"
        >
              <el-option
                style="padding-left: 10px;"
                v-for="item in billSplitList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
        </el-select>
                  </el-form-item>
        
      </template>


            </el-table-column>



          </el-table>
    </div>
  </template>
        </avue-form>
      </el-col>
      <el-col span="12">
        <avue-form :option="excelOption"  v-model="excelForm" :upload-before="uploadBefore">
          <template slot="excelTemplate">
            <el-button type="primary" @click="handleTemplate()">
              点击下载<i class="el-icon-download el-icon--right"></i>
            </el-button>
          </template>

          <template slot="excelFile" slot-scope="scope">
            <el-upload
              class="upload-demo"
              ref="upload"
              :limit="1"
              action=""
              :on-preview="handlePreview"
              :on-change="onChange1"
              :file-list="fileList"
              accept=".xls,.xlsx"
              :auto-upload="false">
              <el-button slot="trigger" size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">请上传 .xls,.xlsx 标准格式文件</div>
            </el-upload>
          </template>
        </avue-form>
      </el-col>
    </el-row>

  </basic-container>
</template>

<script>
  import {getToken} from '@/util/auth';
  import * as XLSX from "xlsx";
import { getDictionaryWithIntKey } from '../../../api/common';
  import {uploadExcel} from "../../../api/v4ward/init/baseimport";

  var DIC = [{
    label: '是',
    value: 0
  }, {
    label: '否',
    value: 1
  }];
  var FEE = [
    {
      label: '小区',
      value: 1
    },
    {
      label: '楼栋',
      value: 3
    }, {
      label: '单元',
      value: 4
    }, {
      label: '房间',
      value: 6
    },
  ];
  var inputNumber1 = (rule, value, callback) => {
    if ((typeof value !== 'number' && isNaN(value)) || value <= 0) {
      callback(new Error('请输入大于 0 的数字！'));
    } else {
      callback();
    }
  };
  var inputNumber2 = (rule, value, callback) => {
    if (!(/(^[1-9]\d*$)/.test(value))) {
      callback(new Error('请输入正整数！'));
    } else {
      callback();
    }
  };
  export default {
    data() {
      return {
        tableData: [{
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        },],
        enableSortTypeAddtionList:[],
        allSortTypeList:[],
        feeTypeList:[],
        priceSetList:[],
        billSplitList:[],
        fileList: [],
        excelForm: {
          offsetFlag:false,
          offsetMoney:"",
          extraFlag:false,
          tableList:[],
        },
        data: [],
        configOption: {
          submitBtn: false,
          emptyBtn: false,
          labelWidth: 130,
          group: [
            {
              icon: 'el-icon-info',
              label: '费项配置',
              collapse: true,
              prop: 'group1',
              column: [
                {
                  label: "费项数据生成",
                  prop: "isItem",
                  span: 12,
                  type: "radio",
                  dicData: DIC,
                  dateType: 'number',
                  rules: [
                    {
                      required: true,
                      message: '请选择房产数据是否生成',
                      trigger: 'blur',
                    },
                  ],
                },
                {
                  label: "计价类型",
                  prop: "priceSet",
                  span: 12,
                  type: "radio",
                  dicData: [
                    {
                      label: '按单价',
                      value: 1
                    },
                    {
                      label: '包干价',
                      value: 2
                    }
                  ],
                  dateType: 'number',
                  rules: [
                    {
                      required: true,
                      message: '请选择计价类型',
                      trigger: 'blur',
                    },
                  ],
                },
                {
                  label: "费项生成规则",
                  prop: "feeItemSet",
                  type: 'select',
                  dataType: 'number',
                  dicData: FEE,
                  span: 12,
                  props: {label: 'label', value: 'value'},
                },
                {
                  label: "费项种类",
                  prop: "feeSort",
                  type: 'select',
                  dataType: 'number',
                  span: 12,
                  dicUrl: '/api/blade-system/dict/dictionary?code=fee_sort',
                  props: {label: 'dictValue', value: 'dictKey'},
                },

                {
                  label: "偏移",
                  prop: "offsetFlag",
                  type: 'switch',
                  dataType: 'boolean',
                  span: 12,
change:(col,val)=>{
  console.log(col,val);
  
}
                  // dicUrl: '/api/blade-system/dict/dictionary?code=fee_sort',
                  // props: {label: 'dictValue', value: 'dictKey'},
                },
                {
                  label: "偏移量",
                  prop: "offsetMoney",
                  type: 'input',
                  dataType: 'string',
                  span: 12,
                  display:false,
             rules:[{
                    required:true,
message: '请输入偏移量', trigger: 'change'
                  }]
                  // formslot: true
                  // dicUrl: '/api/blade-system/dict/dictionary?code=fee_sort',
                  // props: {label: 'dictValue', value: 'dictKey'},
                },

                {
                  label: "附加费项",
                  prop: "extraFlag",
                  type: 'switch',
                  dataType: 'boolean',
                  span: 12,
change:(col,val)=>{
  console.log(col,val);
  
}
                  // dicUrl: '/api/blade-system/dict/dictionary?code=fee_sort',
                  // props: {label: 'dictValue', value: 'dictKey'},
                },

                {
 label: ' ',
 labelWidth:'10',
              prop: 'tableList',
                  type: 'input',
                  dataType: 'string',
                  display:false,
              formslot:true,
              labelslot:true,
                  span: 24,
                  
             rules:[{
                    required:true,
message: '请输入偏移量', trigger: 'change'
                  }]

                },

              ]
            },
            {
              icon: 'el-icon-info',
              label: '优惠政策配置',
              collapse: true,
              prop: 'group1',
              column: [
                {
                  label: "优惠政策生成",
                  prop: "isDis",
                  span: 12,
                  type: "radio",
                  dicData: DIC,
                  dateType: 'number',
                  rules: [
                    {
                      required: true,
                      message: '请选择房产数据是否生成',
                      trigger: 'blur',
                    },
                  ],
                },
                {
                  label: '优惠政策名称',
                  prop: 'preferentName',
                  overHidden: true,
                  rules: [
                    {
                      required: true,
                      message: '请输入优惠政策名称',
                      trigger: 'blur',
                    },
                  ],
                  maxlength: 15,
                  showWordLimit: true,
                },
                {
                  label: '收费方式',
                  prop: 'chargeType',
                  hide: true,
                  type: 'select',
                  props: {
                    label: 'dictValue',
                    value: 'dictKey',
                  },
                  dicUrl: '/api/blade-system/dict/dictionary?code=charge_type',
                  rules: [
                    {
                      required: true,
                      message: '请选择收费方式',
                      trigger: 'change',
                    },
                  ],
                },
                {
                  label: '含本月',
                  prop: 'includFlag',
                  width: 64,
                  type: 'select',
                  valueDefault: 1,
                  dicData: [
                    {
                      label: '是',
                      value: 1,
                    },
                    {
                      label: '否',
                      value: 0,
                    },
                  ],
                  rules: [
                    {
                      required: true,
                      message: '请选择是否含本月',
                      trigger: 'change',
                    },
                  ],
                },
                {
                  label: '收费数',
                  width: 70,
                  prop: 'paycycleNum',
                  rules: [
                    {
                      required: true,
                      message: '请输入收费数',
                      trigger: 'blur',
                    },
                    {
                      validator: inputNumber2,
                      trigger: 'blur',
                    },
                  ],
                  maxlength: 4,
                  showWordLimit: true,
                },
                {
                  label: '优惠方式',
                  prop: 'preferentType',
                  width: 80,
                  type: 'select',
                  dataType: 'number',
                  props: {
                    label: 'dictValue',
                    value: 'dictKey',
                  },
                  dicUrl: '/api/blade-system/dict/dictionary?code=preferent_type',
                  rules: [
                    {
                      required: true,
                      message: '请选择优惠方式',
                      trigger: 'change',
                    },
                  ],
                },
                {
                  label: '优惠数额',
                  prop: 'preferentScore',
                  placeholder: '现金折扣时如打9折，输入0.9',
                  rules: [
                    {
                      required: true,
                      message: '请输入优惠数额',
                      trigger: 'blur',
                    },
                    {
                      validator: inputNumber1,
                      trigger: 'blur',
                    },
                  ],
                  maxlength: 4,
                  showWordLimit: true,
                },
                {
                  label: '禁用时间',
                  prop: 'stopTime',
                  type: 'date',
                  format: 'yyyy-MM-dd',
                  valueFormat: 'yyyy-MM-dd 23:59:59',
                  width: 100,
                  rules: [
                    {
                      required: true,
                      message: '请选择禁用日期',
                      trigger: 'change',
                    },
                  ],
                  pickerOptions: {
                    disabledDate(time) {
                      return time.getTime() <= new Date(new Date().toLocaleDateString()).getTime() - 1;
                    },
                  }
                },
              ]
            },
            {
              icon: 'el-icon-info',
              label: '账单配置',
              collapse: true,
              prop: 'group1',
              column: [
                {
                  label: "账单数据生成",
                  prop: "isBill",
                  span: 12,
                  type: "radio",
                  dicData: DIC,
                  dateType: 'number',
                  rules: [
                    {
                      required: true,
                      message: '请选择房产数据是否生成',
                      trigger: 'blur',
                    },
                  ],
                },
                {
                  label: "缴费截止时间",
                  prop: "endMonth",
                  type: "month",
                  span: 12,
                  format: 'yyyy-MM',
                  valueFormat: 'yyyyMM',
                },
              ]
            }
          ]
        },
        excelOption: {
          submitBtn: false,
          emptyBtn: false,
          labelWidth: 130,
          group: [
            {
              icon: 'el-icon-info',
              label: '基础数据生成',
              collapse: true,
              prop: 'group1',
              column: [
                {
                  label: '基础数据模板下载',
                  prop: 'excelTemplate',
                  formslot: true,
                  span: 24,
                },
                {
                  label: '基础数据生成',
                  prop: 'excelFile',
                  type: 'upload',
                  formslot: true,
                  loadText: '基础数据上传中，请稍等',
                  action: '/api/baseImport/uploadExcel2',
                  span: 24,
                  tip: '请上传 .xls,.xlsx 标准格式文件，文件不要超过2mb',
                },
              ]
            }]
        },
      };
    },
    watch: {
      'excelForm.offsetFlag': {
        handler(val) {
          console.log("extraFLag============>",val);
          this.handlerHideOffsetNum(val);
        },
        immediate: true,
      },
      'excelForm.extraFlag': {
        handler(val) {
          console.log("extraFlag============>",val);
          this.handlerHideTableList(val);
        },
        immediate: true,
      },
      'excelForm.isItem': {
        handler(val) {
          this.handlerHide1(val);
        },
        immediate: true,
      },
      'excelForm.isDis': {
        handler(val) {
          this.handlerHide2(val);
        },
        immediate: true,
      },
      'excelForm.isBill': {
        handler(val) {
          this.handlerHide3(val);
        },
        immediate: true,
      },
    },
    mounted() {
      this.excelForm = {
        isItem: 0,
        isBill: 0,
        isDis: 0,
        priceSet: 1,
        preferentType:"",
        extraFLag:false,
        offsetFlag:false,
        tableList:[],
      }
    this.initAllSelectList();
    },
    methods: {
      
    initSortTypeList: function () {
      getDictionaryWithIntKey('sort_type').then((data) => {
        this.allSortTypeList = data.data;
        // this.enableSortTypeList = data.data;
        this.enableSortTypeAddtionList = data.data;
        this.enableSortTypeAddtionList = this.allSortTypeList.filter(function (s) {
          return Math.floor(parseInt(s.dictKey) / 10) == 4;
        });
      });
    },
    initAllSelectList: function () {
      this.getPriceSetList();
      this.getBillSplitList();
      this.initSortTypeList();
      this.initFeeTypeList();
    },
    
    initFeeTypeList: function () {
      getDictionaryWithIntKey('fee_type').then((data) => {
        this.feeTypeList = data.data;
      });
    },
    getPriceSetList: function (){
      getDictionaryWithIntKey('price_set').then((data) => {
        this.priceSetList = data.data;
      });
    },
    getBillSplitList: function (){
      getDictionaryWithIntKey('bill_split').then((data) => {
        this.billSplitList = data.data;
      });
    },
    addtionFeeItemChange(val){
      console.log("addtionFeeItemChange=====================>",val);
      this.tableData = [];
      this.excelForm.tableList = [];
      this.excelForm = _.cloneDeep(this.form);
    },
    offsetNumChange(val){
      console.log("offsetNumChange=====================>",val);
      this.excelForm.offsetMoney = '';
    },
    deleteItemHandler(scope){
      console.log("deleteItemHandler===========>",scope);
      this.tableData.splice(scope.$index,1);
      this.excelForm.tableList.splice(scope.$index,1);
      this.excelForm = _.cloneDeep(this.form);
    },
    addItemHandler(){
      this.tableData.push({});
      this.excelForm.tableList.push({});
      this.excelForm = _.cloneDeep(this.form);
    },
      onChange1(file, done){
        this.$refs.config.validate((valid) => {
          if (valid) {
            console.log('------------------',file)
            console.log('------------------',this.excelForm)
            const formData = new FormData();
            if (this.excelForm.feeSort && this.excelForm.feeSort != 'undefined'){
              formData.append('feeSort', this.excelForm.feeSort);
            }
            if (this.excelForm.feeItemSet && this.excelForm.feeItemSet != 'undefined'){
              formData.append('feeItemSet', this.excelForm.feeItemSet);
            }
            formData.append('extraFlag', this.excelForm.extraFlag?'1':'0');
            if(this.excelForm.offsetFlag){
              formData.append('offsetMoney', this.excelForm.offsetMoney);
            }
            formData.append('offsetFlag', this.excelForm.offsetFlag?'1':'0');
            if(this.excelForm.tableList.length>0){
              this.excelForm.tableList.forEach((item,i)=>{

                formData.append(`feeItemsetSubs[${i}].sortType`,item.sortType);

                formData.append(`feeItemsetSubs[${i}].feeType`,item.feeType);

                formData.append(`feeItemsetSubs[${i}].priceSet`,item.priceSet);

                formData.append(`feeItemsetSubs[${i}].unitPrice`,item.unitPrice);

                formData.append(`feeItemsetSubs[${i}].splitFlag`,item.splitFlag);
                
              });
            }
            formData.append('chargeType', this.excelForm.chargeType);
            formData.append('endMonth', this.excelForm.endMonth);
            formData.append('excelTemplate', this.excelForm.excelTemplate);
            formData.append('includFlag', this.excelForm.includFlag);
            formData.append('isBill', this.excelForm.isBill);
            formData.append('isDis', this.excelForm.isDis);
            formData.append('isItem', this.excelForm.isItem);
            formData.append('paycycleNum', this.excelForm.paycycleNum);
            formData.append('preferentName', this.excelForm.preferentName);
            formData.append('preferentScore', this.excelForm.preferentScore);
            formData.append('priceSet', this.excelForm.priceSet);
            formData.append('stopTime', this.excelForm.stopTime);
            formData.append('preferentType', this.excelForm.preferentType);
            formData.append('file', file.raw);
            uploadExcel(formData).then(
              (res) => {
                console.log(res)
                this.$message.success(res.msg);
                this.onLoad();
              },
              (error) => {
                done();
                console.log(error);
              }
            );
          } else {
            done();
            // load.close();
            // loading();
          }
        });
      },

      handlerHideOffsetNum(val) {
        console.log("handlerHideOffsetNum====>",val===0);
        var offsetMoney = this.findObject(this.configOption.group[0].column, 'offsetMoney');
        if (val) {
          offsetMoney.display = true;
          offsetMoney.rules = [
            {
              required: true,
              message: '请选择附加费',
              trigger: 'change',
            },
          ];
        }else{
          offsetMoney.display = false;
          offsetMoney.rules = [
          ];
        }
      },
      handlerHideTableList(val) {
        console.log("handlerHideTableList====>",val===0);
        var tableListColumn = this.findObject(this.configOption.group[0].column, 'tableList');
        if (val) {
          tableListColumn.display = true;
          tableListColumn.rules = [
            {
              required: true,
              message: '请选择附加费',
              trigger: 'change',
            },
          ];
        }else{
          tableListColumn.display = false;
          tableListColumn.rules = [
          ];
        }
      },

      handlerHide1(val) {
        var isBill = this.findObject(this.configOption.group[2].column, 'isBill');
        var isDis = this.findObject(this.configOption.group[1].column, 'isDis');
        var feeItemSet = this.findObject(this.configOption.group[0].column, 'feeItemSet');
        var feeSort = this.findObject(this.configOption.group[0].column, 'feeSort');
        var endMonth = this.findObject(this.configOption.group[2].column, 'endMonth');
        var priceSet = this.findObject(this.configOption.group[0].column, 'priceSet');
        if (val === 0) {
          isBill.display = true;
          isBill.rules = [
            {
              required: true,
              message: '请选择账单数据生成',
              trigger: 'change',
            },
          ];
          isDis.display = true;
          isDis.rules = [
            {
              required: true,
              message: '请选择账单数据生成',
              trigger: 'change',
            },
          ];
          priceSet.display = true;
          priceSet.rules = [
            {
              required: true,
              message: '请选择计价类型',
              trigger: 'change',
            },
          ];
          feeItemSet.display = true;
          feeItemSet.rules = [
            {
              required: true,
              message: '请选择费项生成规则',
              trigger: 'change',
            },
          ];
          feeSort.display = true;
          feeSort.rules = [
            {
              required: true,
              message: '请选择费用种类',
              trigger: 'change',
            },
          ];
          endMonth.display = true;
          endMonth.rules = [
            {
              required: true,
              message: '请填写缴费截止时间',
              trigger: 'change',
            },
          ];
          this.configOption.group[1].column.forEach(value => {
            value.display = true;
            value.rules = [
              {
                required: true,
                message: '该选项必填',
                trigger: 'change',
              },
            ]
            if (value.prop === 'paycycleNum') {
              value.rules.push({
                validator: inputNumber2,
                trigger: 'blur',
              })
            }
            if (value.prop === 'preferentScore') {
              value.rules.push({
                validator: inputNumber1,
                trigger: 'blur',
              })
            }
          })
        } else {
          isBill.display = false;
          isBill.rules = [];
          feeItemSet.display = false;
          feeItemSet.rules = [];
          feeSort.display = false;
          feeSort.rules = [];
          endMonth.display = false;
          endMonth.rules = [];
          priceSet.display = false;
          priceSet.rules = [];
          isDis.display = false;
          isDis.rules = [];
          this.configOption.group[1].column.forEach(value => {
            value.display = false;
            value.rules = []
          })
        }
      },
      handlerHide2(val) {
        if (val === 0) {
          this.configOption.group[1].column.forEach(value => {
            value.display = true;
            value.rules = [
              {
                required: true,
                message: '该选项必填',
                trigger: 'change',
              },
            ]
            if (value.prop === 'paycycleNum') {
              value.rules.push({
                validator: inputNumber2,
                trigger: 'blur',
              })
            }
            if (value.prop === 'preferentScore') {
              value.rules.push({
                validator: inputNumber1,
                trigger: 'blur',
              })
            }
          })
        } else {
          this.configOption.group[1].column.forEach(value => {
            if (value.prop !== 'isDis') {
              value.display = false;
              value.rules = []
            }
          })
        }
      },
      handlerHide3(val) {
        var endMonth = this.findObject(this.configOption.group[2].column, 'endMonth');
        if (val === 0) {
          endMonth.display = true;
          endMonth.rules = [
            {
              required: true,
              message: '该选项必填',
              trigger: 'change',
            },
          ]
        } else {
          endMonth.display = false;
          endMonth.rules = []
        }
      },
      uploadBefore(file, done, loading) {
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
        //校验是否为excel文件
        let len = file.name.split('.').length;
        const isExcel = (file.name.split('.')[len - 1] === 'xls' || file.name.split('.')[len - 1] === 'xlsx');
        if (!isExcel) {
          this.alertMsg('请上传 .xls,.xlsx 标准格式文件', "error");
          load.close();
          loading();
          return;
        }
        //校验文件大小
        const isLt2M = file.size / 1024 / 1024 > 2;
        if (isLt2M) {
          this.alertMsg('文件大小不能超过2MB!', "error");
          load.close();
          loading();
          return;
        }
      },
      readExcel(file) {// 解析Excel
        return new Promise(function (resolve, reject) {// 返回Promise对象
          const reader = new FileReader();
          reader.onload = (e) => {// 异步执行
            try {
              // 以二进制流方式读取得到整份excel表格对象
              var workbook = XLSX.read(e.target.result, {type: 'binary'});
            } catch (e) {
              reject('文件损坏');
            }       // 表格的表格范围，可用于判断表头是否数量是否正确
            if (!workbook.Sheets["住户数据"]) {
              reject("文件中没有“住户数据”的表,请检查与模板格式是否一致");
              return;
            }
            let data = [];
            if (workbook.Sheets.hasOwnProperty('住户数据')) {
              data = data.concat(XLSX.utils.sheet_to_json(workbook.Sheets["住户数据"]))
            }
            if (data.length === 0) {
              reject("无数据，请添加数据后再上传");
            }
            var isNum = /(^[1-9]\d*$)/;
            var isFloat = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
            var reg = /^\b[1-3]\d{3}(0[1-9]|1[0-2])$/;
            //校验数据格式
            data.forEach((value, index) => {
              if (!value['序号'] || !(isNum.test(value['序号']))) {
                reject((index + 2) + '行的"序号"为必填，并且为正整数');
                return;
              }
              else if (!value['小区']) {
                reject((index + 2) + '行的"小区"为必填');
                return;
              }
              /*else if (!value['楼栋'] || !(isNum.test(value['楼栋']))) {
                reject((index + 2) + '行的"楼栋"为必填，并且为正整数');
                return;
              } else if (!value['单元'] || !(isNum.test(value['单元']))) {
                reject((index + 2) + '行的"单元"为必填，并且为正整数');
                return;
              } else if (!value['房间'] || !(isNum.test(value['房间']))) {
                reject((index + 2) + '行的"房间"为必填，并且为正整数');
                return;
              }*/
              else if (!value['姓名']) {
                reject((index + 2) + '行的"姓名"为必填，请检查');
                return;
              }
              /*else if (!value['电话']) {
                reject((index + 2) + '行的"电话"为必填，请检查');
                return;
              } */
              else if (!value['建筑面积(M²)'] || !(isFloat.test(value['建筑面积(M²)']))) {
                reject((index + 2) + '行的"建筑面积(M²)"格式不对，请输入大于0保留两位的小数');
                return;
              }
              else if (!value['房屋面积(M²)'] || !(isFloat.test(value['房屋面积(M²)']))) {
                reject((index + 2) + '行的"房屋面积(M²)"格式不对，请输入大于0保留两位的小数');
                return;
              }
              /*else if (!value['每月物业费M²/元'] || !(isFloat.test(value['每月物业费M²/元']))) {
                reject((index + 2) + '行的"每月物业费M²/元"格式不对，请输入大于0保留两位的小数');
                return;
              }*/
              else if (value['物业费截止时间'] && !(reg.test(value['物业费截止时间']))) {
                reject((index + 2) + '行的"物业费截止时间"格式不对，请输入“yyyyMM”六位数字格式');
                return;
              }
            });
            //组装数据返回
            const uploadData = data.map(item => {
              return {
                indexNo: item['序号'],
                areaName: item['小区'],
                buildingName: item['楼栋'],
                unitName: item['单元'],
                roomName: item['房间'],
                name: item['姓名'],
                phone: item['电话'],
                sex: item['性别'],
                idCard: item['身份证号码'],
                area: item['建筑面积(M²)'],
                usableArea: item['房屋面积(M²)'],
                propertyFee: item['每月物业费M²/元'],
                deadTime: item['物业费截止时间'],
                manageType: item['管理分区']
              }
            });
            resolve(uploadData);
          };
          reader.readAsBinaryString(file);
        });
      },
      importData(load) {
        // this.excelForm.preferentType = this.excelForm.preferentType? this.excelForm.preferentType : ""
        uploadExcel({baseList: this.data, configVO: this.excelForm}).then((res) => {
          this.excelForm = {};
          this.$message.success(res.msg);
          load.close();
        }).catch((error) => {
          console.log(error);
          load.close();
          this.alertMsg(error, "error");
        })
      },
      alertMsg(msg, type) {
        this.$confirm(msg, {
          confirmButtonText: "确定",
          type: type
        })
          .then(() => {
          })
          .then(() => {
          });
      },
      handleTemplate() {
        window.open(`/api/baseImport/export-template?Blade-Auth=${getToken()}`);
      },
    }
  };
</script>

<style scoped>
  /deep/ .el-upload-list__item {
    display: none;
  }
</style>
